export const concordance = {
	abide:
		"John 15:5-7,10,John 8:31-33,34,6:56,1 John 2:6,Luke 10:38-42,John 11:26,1 John 2:20,24,27-28,1 John 3:6;",
	abomination:
		"Pro 28:9,Pro 17:15, Pro 29:7,15:8,Pro 21:27,Eze 20:8,Eze 24:13;",
	"aim to lead a quiet and peaceful life":
		"1 Thes 4:11,1 Tim 2:2, Rom 12:18, Heb 12:14;",
	"all world followed dragon": "Rev 13:7,12,Rev 13:3-4,20:2,Rev 17:1-2,15;",
	alpha: "Rev 22:13, John 1:1,Pro 8:22-30;",
	"always saved disproved":
		"Heb 10:26-29,36,39,1 Cor 9:27, 2 Pet 2:20-22, Heb 3:12-13, 2 Cor 13:5, 1 Tim 1:19,Mark 4:16-19,Ezekiel 18:24,26;",
	anger:
		"Col 3:8,Eph 4:31,4:26,Mat 5:21-22,James 1:20,1 John 3:15, Pro 22:24-25,Ecc 7:9;",
	anointing:
		"1 John 2:10,20,Mat 23:10,1 John 2:26-27, 2 John 1:7, 2 Cor 1:21,1 John 2:22;",
	antichrist:
		"1 John 2:18-19,Mark 13:22, 2 John 1:7, 1 John 4:3, 1 John 2:22, Rev 13:17-18;",
	apart: "1 Tim 6:16,Heb 7:26,1 John 3:5, Isa 35:8,52:1,Rev 21:8,27,Psa 50:21;",
	appearance:
		"Tit 2:13,2 Pet 3:12,2 Cor 4:6,3:18,Mat 5:8,John 14:21-23,1 John 3:2-3,1 John 2:28,  Col 3:4, Isa 30:20;",
	author: "Mat 11:28 ,Heb 12:2, Heb 5:9,Col 1:15-17, John 6:37;",
	authority: "John 5:26-27,John 7:28,Rev 2:26-27,Luke 19:17,Luke 9:1;",
	authorized: "Eph 4:11-13, Luke 6:39-43, Tit 1:16;",
	banned: "Eph 5:5-6, Gal 5:19-21, 1 Cor 15:50,6:9-10,Rom 2:12;",
	"baptism of death":
		"2 Tim 2:11,Mar 10:38-39,Rom 6:4,Col 2:11-12,Phil 3:10,Rom 16:20;",
	"baptism of fire":
		"Eph 4:4-5,Mat 3:11-12,Rom 6:4, Col 2:11-12,Acts 1:5,1 Cor 1:14-17;",
	"be a good and loyal servant": "Eph 6:5-8,1 Pet 2:18,Col 3:22,1 Tim 6:1;",
	bear: "Matthew 10:38,Luke 14:27,33,9:23,1 Corinthians 1:18,Matthew 16:24-25,Galatians 5:24,2:20,2 Corinthians 4:10-11",
	"bear the cross":
		"Mat 16:24-25,1 Cor 1:18,Gal 5:24,2:20,Luke 14:27,33,Mat 10:38,2 Cor 4:10-11;",
	beast:
		"Ecc 3:18, Psa 73:22,Psalms 49:12,20, Tit 1:12-13,2 Pet 2:12, Jude 1:10;",
	beauty: "Psa 27:4,Isa 28:5, 33:17,Psa 50:2,90:17,Psa 96:6,9;",
	"Being led in Old Testament":
		"Pro 4:11, Psa 32:8,Psa 48:14,Psa 73:24, Isa 58:11,Isa 30:20-21;",
	believe: "John 3:16,John 6:29,John 1:7,9,John 12:36,3:21;",
	belong:
		"Tit 2:14,Gal 5:24,Rom 8:9,John 14:23,2 Cor 6:16,John 10:27, 8:47,John 18:37;",
	"blackest darkness": "2 Peter 2:14-19,Jude 1:11-13;",
	"blind guide": "Mat 15:14, Luke 6:39-42,1 John 3:7-8,2 Cor 11:15;",
	"blood will be disastrous": "1 John 1:7, Heb 10:29, Isa 24:5, Jude 1:4,5,8;",
	"blots out sins": "Isaiah 43:25;",
	boasting:
		"James 4:16,Psa 12:3,1 John 2:16,1 Cor 13:4,2 Cor 11:30,Gal 6:14,Psa 94:4,5:5;",
	"born again": "1 John 5:1;",
	"bring glory to God": "John 15:8,Mat 5:16,John 7:18, Phil 2:13;",
	"brings salvation": "Heb 9:28,1 John 3:2-3,Tit 2:11-14,Jude 1:21;",
	"broad easy way": "Mat  7:13-14,Luke 13:23-24,Proverbs 14:12,16:25,21:2;",
	"broke covenant": "Isa 24:5,Heb 10:29,Jude 1:4;",
	"broken heart":
		"Psa 38:8,34:18,51:17,Isa 61:1,Isa 57:15,66:2,Pro 13:12,18:12,15:13,Psa 69:20,147:3;",
	"bruise head": "Gen 3:13-15, Rom 16:20;",
	buried: "Col 2:11-12,Rom 6:4;",
	"called within":
		"Rom 1:19,Deu 30:10-14,Rom 10:8,Rom 10:17,Gal 3:2,5, Mat 11:27,John 6:63;",
	carnal: "1 Cor 3:1,3,Eph  2:2-3, Rom 8:6-7;",
	"carnal mind":
		"Eph 4:17,2:3,,Rom 8:7-8,Isa 55:7,Isa 65:2,55:8-9,Eph 2:3,Jer 16:12, 31:33,Prov 15:26,Psa 94:11;",
	"cast behind":
		"1 Kings 14:9,Psalm 50:16-17,Isa 5:24,Ezekiel 23:35,Nehemiah 9:26;",
	"cast cares": "1 Pet 5:7,Mat 6:31-35, Heb 13:5;",
	"cease trusting man": "Isa 2:22, 45:22, Mat 23:10,1 John 2:27, Mat 10:38;",
	"children of the light": "Eph 5:8,1 Thes 5:5,John 12:36,Luke 16:8;",
	"Christ fills heaven and earth.": "Jer 23:24, Eph 4:10,Daniel 2:35;",
	"Christ given to every man":
		"1 Cor 12:7,Tit 2:11-12,John 1:7,9,Rom 10:8, Rev 3:20;",
	"Christ in You":
		"Eph 3:17, 2 Cor 13:5,Acts 17:26-28,Col 1:27,2 Cor 4:6,3:18, Gal 4:6, 19,Col 3:11,16,Rom 8:9-10;",
	"Christ revealed":
		"1 John 3:8,John 14:21-23,Gal 1:15-16,Isa 30:20,1 Pet 1:13,4:13,2 Cor 4:10-11,Luke 10:22,17:30;",
	"Christ speaks":
		"Luke 6:47-49,John 6:63,8:47,John 10:27,18:37,Heb 12:25, 4:7, 1:2,Eph 4:21,Mat 23:10;",
	"Christ the creator":
		"John 1:1,3,Col 1:16,Heb 11:3,1:2,2 Pet 3:5-7,Psa 33:6,1 Cor 8:6;",
	"Christ the life": "John 1:1-4, John 14:6,John 8:12,John 10:10,John 20:31;",
	"Christ the light":
		"John 1:4-5,John 1:9,John 8:12,John 12:46,John 12:36,1John 1:5;",
	"Christ the substance": "Hebrews 10:1-3,12-14, Col 2:16-17;",
	"Christ the Word":
		"John 1:1,14,Rev 19:13,16,Heb 11:3,Psa 33:6,2 Peter 3:5-7,1 Pet 1:23,25,Deu 30:14;",
	"christ through all":
		"Col 3:11, Col 1:17,Jer 23:24,Acts 17:26-28,Rom 9:5,Eph 4:6,Dan 2:35;",
	circumcise:
		"Rom 8:13,Col 3:5,Jer 4:4,Rom 2:29,Col 2:11,Eph 4:22, Deu 10:16,30:6 ,1 John 3:8;",
	cleanse:
		"1 John 1:7,9,John 15:3,13:8,Eph 5:25-27,Isa 35:8, 52:1,Psa  119:9,51:2,10,19:12,Luke 11:39,41,2 Cor 7:1,Heb 1:3,Heb 10:14,22;",
	cloud:
		"Mat 26:64,Mark 14:62, Luke 9:34-35,1 Thes 4:17,Dan 7:13,Rev 14:14-16,Rev 1:7,Rev 11:12,Heb 12:1;",
	"colossal error": "Deuteronomy 30:10,14;",
	"come forth":
		"John 11:25-26,43, John 5:24-25,\n               Isaiah 49:6,9 ;",
	"come to me":
		"Isa 55:1,3,Mat 11:28-29,Luke 6:47-49,John 5:39-40,John 6:35,37;",
	comes: "John 15:26,John 16:13,John 14:3,John 16:8,1Cor 4:5;",
	"coming of the Lord":
		"Luke 17:34-35,John 14:3,John 14:21-23, Heb 9:28,Mal 3:2-3,4:1-3,Mat 5:8;",
	commands:
		"Rev 14:12,Mat 28:20,John 14:15, 14:21,John 15:10, 8:55, 8:51,1 John 2:3-4,3:22,24,5:2,Rom 7:9,1 Cor 7:19,14:37,1 Thes 4:2,Acts 1:2;",
	complain: "Phil 2:14, Num 11:1,31-34, 1 Cor 10:10;",
	conceit: "Gal 5:26,Rom 11:20,25,12:16,Pro 26:5,28:11,Phil 2:3;",
	condition:
		"1 John 3:7-10, Matthew 5:48, Luke 6:36, Luke 9:23-24,14:33, Hebrews 12:14, 1 John 3:3, 1 Peter 1:15-16, 1 John 2:6, 1 John 4:17",
	conditions:
		"1 John 3:7-10, Matthew 5:48, Luke 6:36, Luke 9:23-24,14:33, Hebrews 12:14, 1 John 3:3, 1 Peter 1:15-16, 1 John 2:6, 1 John 4:17",
	confidence: "Heb 3:6,14, Heb 10:35-39, Phil 1:6,Isaiah 30:15,Psa 27:14 ;",
	consecrate: "John 17:17,Heb 10:20, John 17:19;",
	"consequence free sin":
		"Luke 13:3,5, Eph 5:5-6,John 5:14,8:11,Acts 3:23,Mark 9:43,45,47-48,Gal 5:19-21;",
	"contentious woman": "Pro 21:9,19,Pro 25:24,Pro 27:15,16;",
	"count the costs": "Luke 14:26,28,29,31,33, Mat 10:34-37,19:29;",
	"covenant with death":
		"Isaiah 28:15,Isa 28:18,2 Cor 5:10,Proverb 24:12,Proverbs 24:24;",
	covetous:
		"Psa 119:36, Mark 7:21-23,Eph 5:3,5,1 Cor 5:11,Luke 12:15,Mark 8:36, Exo 20:17,1 Tim 6:5,10,Eze 33:31-32, Col 3:5;",
	covetousness:
		"Psa 119:36, Mark 7:21-23,Eph 5:3,5,1 Cor 5:11,Luke 12:15,Mark 8:36, Exo 20:17,1 Tim 6:5,10,Eze 33:31-32, Col 3:5;",
	"creation by the word": "Heb 11:3,  2 Pet 3:5-7,Psa 33:6;",
	cross:
		"Matthew 16:24-25, 1 Corinthians 1:18,1:17, Galatians 5:24, Galatians 2:20,6:14, 2 Corinthians 4:10-11, Philippians 3:18-19, Luke 14:27",
	crucify:
		"2 Cor 4:10,2 Cor 4:11,Luke 9:23-24,Gal  5:24, 6:14,Gal 2:20, Rom 6:6-7,Rom 8:13,1 Pet 2:21;",
	crucified:
		"2 Cor 4:10,2 Cor 4:11,Luke 9:23-24,Gal  5:24, 6:14,Gal 2:20, Rom 6:6-7,Rom 8:13,1 Pet 2:21;",
	daily: "Luke 9:23,Luke 11:3,1 Cor 15:31,2 Cor 4:10-11, Mat 16:24;",
	darkness:
		"John 11:10,Psa 82:5,107:10,John 1:5,Pro 2:13,1 John 1:6-7,Luke 11:34,Luke 1:78-79;",
	"day of the Lord":
		"Mal 4:1-2,3:2-3,2 Pet 3:10-12,Isa 33:11-16,Luke 21:31,34-35,Amos 5:18,2 Cor 1:14,1 Cor3:13, Acts 2:20;",
	"dead to the life of God":
		"Gen 2:17, 3:24,Pro 21:16, Mat 8:22, Rev 3:1, Eph 2:5-6, John 5:25, Luke 24:5,9:60,Rom 6:13;",
	"dead works": "Heb 9:14,10:22,Heb 6:1;",
	"deceptive words of false teachers":
		"Rom 16:18,2 Peter 2:1-3,2 Tim 4:3-4, Jude 1:4-5,8,1 John 3:6-8 ;",
	defiled:
		"Mat 15:18-19,Jer 17:9,16:12,Mark 7:21-23,Rev 21:27,2 Cor 5:10, Heb 7:26;",
	deliver:
		"Luke 11:4,Mat 6:13,Col 1:13,Luke 4:18,Rom 11:26,Luke 1:74, Rom 7:24,25, Rom 8:21;",
	"demons believe": "James 2:19,Luke 8:28, 4:41 ,Mark 5:7 ,3:11, Mat 8:29;",
	"demons called birds":
		"Mark 4:4,15,Mat 13:4,19,Luke 8:5,12,Rev 18:2,Luke 17:37",
	"denies Him": "John 8:34,Jude 1:4, Tit 1:16, 2 Pet 2:1,Mark 7:6,14:44-45;",
	"denies him": "John 8:34,Jude 1:4, Tit 1:16, 2 Pet 2:1,Mark 7:6,14:44-45;",
	"deny yourself":
		"Eph 2:2-3,Luke 9:23, Gal 5:17,Tit 2:11-12, 1 Pet 4:2, Mat 7:21;",
	"destroy works of devil":
		"2 Thes 2:8,1 John 3:8,Heb 2:14-15,Acts 26:17-18,1 John 3:5,Rom 16:20, Gal 2:20;",
	"destroys sin":
		"Rom 8:13,Col 2:11,Col 3:5,8,1 John 3:8,Rom 16:20,1 John 3:5,Tit 2:14,1 John 1:7;",
	"die daily": "2 Cor 4:11,1 Cor 15:31, 2 Cor 4:10;",
	"die to the law through the law": "Rom 7:1,4-6,9;",
	"different gospel": "2 Cor 11:4,Gal 1:9,11-12,Acts 26:15-18;",
	"diligence in listening and seeking":
		"Exo 15:26,Pro 8:17, Isa 55:2,Heb 11:6,Heb 4:11,Deu 28:1,Pro 7:15,Psa 77:6,Pro 11:27;",
	"diligent in work": "Pro 10:4,22:29,1 Tim 5:8,Col 3:23,Pro12:24,21:5;",
	disciple:
		"Luke 14:33,Luke 14:27,John 13:35,John 15:8,Luke 14:26,Gal 5:24,John 8:31;",
	"do everything as if serving the Lord": "Col 3:18-23;",
	"doctrines of man":
		"Col 2:8,20-22,Mat 15:7-8,Mat 15:9, 2 Tim 4:3-4,2 Pet 2:18-19,Titus 1:14;",
	"does not know God": "1 John 3:6, Titus1:16,John 5:37,Jude 1:4;",
	drawn: "John 6:44, Mat 22:14;",
	"draws wrath of God": "Rom 1:18, Eph 5:3,5-6, Rom 2:8,12,15, Col 3:5-6;",
	dwell:
		"Lev 26:11-12,John 14:23,John 1:14,2 Cor 6:16,Eze 37:27,36:26-28,Rev 21:3, Col 3:16;",
	"earth cleansed of all sin":
		"Psa 37:38,110:6, Pro 2:22,Isa 24:6,Isa 1:28,13:9,Isa 26:21,Isa 28:22,Jer 25:29;",
	end: "Mat 10:22,24:13,Mark 13:13,1 Pet 1:9,13,Rom 6:22,1 Cor 1:8,2 Cor 1:13,Heb 3:6,14,Heb 6:11;",
	"end prophecies": "Mat 24:29-34,Mark 13:24-30, Luke 21:27-32;",
	"end times":
		"Heb 1:2, Acts 2:16-17, 2 Pet 3:10-12,1 John 2:18,John 12:48,2 Cor 5:17,Mat 16:27-28,Mark 8:39,9:1,Luke 9:26-27;",
	endure:
		"Mat 10:22,13:21,2 Thes 1:4-5,Heb 12:7,6:15, Heb 10:36,39,12:7,Luke 21:19,Luke 8:15,Acts 14:22,James 1:12,5:11;",
	endured:
		"Mat 10:22,13:21,2 Thes 1:4-5,Heb 12:7,6:15, Heb 10:36,39,12:7,Luke 21:19,Luke 8:15,Acts 14:22,James 1:12,5:11;",
	"enemy of cross": "Phil 3:18-19,Gal 5:11,2 Co 2:15-16, 1 Cor 1:18;",
	engrafted: "James 1:21,John 6:63,2 Cor 3:6;",
	"enlightens every man":
		"John 1:1,4,John 1:7,9, John 3:15,John 12:36,John 8:12,John 12:46;",
	"enmity to God": "1 John 2:15-16, James 4:4, Rom 8:6-7;",
	envy: "Gal 5:26, Rom 13:13,Gal 5:19-21, Mark 7:21-23,2 Cor 12:20, James 3:14,16, James 4:5, Titus 3:3;",
	"essential works": "James 2:20-24, Gal 5:6,Luke 14:27,33,Tit 2:14,John 3:21;",
	"establish the law": "Rom 3:31, Heb 10:16;",
	"eternal life":
		"John 6:40,Jude 1:21,Mat 19:16,21,John 3:15, Heb 5:9,John 5:24;",
	"everlasting life":
		"John 12:50,Gal 6:8, Luke 18:29-30,John 4:14,6:27,Rom 6:22;",
	"every effort": "Luke 13:24-28,Heb 4:11,2 Pet 1:5-6,9-11;",
	"every man given the Spirit of God":
		"1 Cor 12:7, John 1:7,9,Tit 2:11-12,Acts 2:14-18;",
	"every man judged":
		"Mat 16:27,12:36-37,Rom 2:6,14-16,2 Cor 5:10,1 Pet 1:16-17,Pro 24:12,Rev 2:23,20:13;",
	"everyone experiences the day": "Luke 21:31,34-35, Rev 1:7, 1 Cor 3:13;",
	"evil heart":
		"Mark 7:21-23, Mat 15:18-19,Jer 16:12,Jer 17:9,7:24,Gen 8:21,Jer 11:8;",
	exclusion:
		"Luke 13:3,5, Ephesians 5:3,5-6, Mark 7:21-23, Mark 9:43,45,47-48, Romans 8:8,13, Galatians 5:19-21, 1 Corinthians 6:9-10, 1 Corinthians 15:50, Revelation 21:27",
	exclusions: 
		"Luke 13:3,5, Ephesians 5:3,5-6, Mark 7:21-23, Mark 9:43,45,47-48, Romans 8:8,13, Galatians 5:19-21, 1 Corinthians 6:9-10, 1 Corinthians 15:50, Revelation 21:27",
	expose: "Rom 4:12,Rom 4:3;",
	fables: "2 Timothy 4:3-4;",
	"Face in Old Testament":
		"Gen 32:30,  Psa 17:15,Acts 2:25,  Psa 105:4,27:8, 1 Chr 16:11, Num 12:8, Job 33:26,Exo 33:11;",
	"fail to endure": "Mark 4:16-20,Mat 13:18-23,Luke 8:13-15, Heb 10:39;",
	"faint not": "Heb 12:3,5, Gal 6:9,Rev 2:3;",
	"faith is a journey":
		"Rom 10:8,17,Heb 12:2,11:1,Rom 1:17,2 Pet 1:5-7, Mat 11:27;",
	"faith is a series of revelations":
		"Rom 10:8,Rom 10:17,Heb 12:2,Rom 1:17,Rom 1:19,2 Pet 1:5-7, Mat 11:27;",
	"faith is to hear":
		"Deu 30:10-14, Eph 4:21,1:13,Rom 10:8,Rom 10:17,Gal 3:2,5,Heb4:7,12:25;",
	"faith revealed":
		"Mat 11:27,Gal 3:23,Rom 1:17,Rom 10:8,Rom 10:17,Heb 12:2,Rom 1:19,1 Cor 2:5;",
	"faith that frees": "Gal 3:23,25,Gal 5:22-23, Gal 5:18;",
	"faith that purifies": "Acts 15:9,Acts 26:18;",
	"faith with power":
		"2 Thes 1:11, Gal 5:6, John 3:21, Mat 21:21-22, Mat 14:25,28-31;",
	"fallen man":
		"Rom 8:8,Gen 3:17,23-24,Eph 2:2-3, Eph 4:17,Jer 16:12,1 Thes 4:3-5,7;",
	"false apostles":
		"2 Cor 11:13-15,2 Pet 2:1-3,18-19,Mark 13:22,1 John 4:1, 2:18-19,26,Jude 1:4,Rom 16:18,2 Tim 4:3-4, Phil 3:18;",
	"false apostles gone into the world":
		"1 John 4:1, 2:18-19,2 John 1:7,1 Tim 4:1-2, 2 Tim 4:3-4,2 Cor 11:13-15,2 Pet 2:1-3,18-19,Acts 20:29-31,Rom 16:18;",
	"false Jesus": "2 Cor 11:4, Gal 1:8-9, Jude 1:4;",
	"false prophets imagination":
		"Gen 6:5,8:21,Jer 14:14,23:26,Eze 13:2,10,22, Jer 11:8,Jer 16:12,Jer 7:24,5:31, Mark 7:21-22;",
	"false prophets Old Testament":
		"Deu 18:20,Eze 13:2-3,10,22,Mic 3:5,2:11,Jer 23:32,34,26,38-40,Isa 56:10-11,Jer 5:31,6:14,Jer 23:16-17,Jer 23:25,26,27,26,29-32;",
	"false salvation":
		"2 Cor 11:13,15,2 Pet 2:2,19,Eph 5:5-6,1 John 3:8, Luke 14:27,9:24;",
	"Father in you": "Deu 30:10,14,Acts 17:26-28,Eph 4:6;",
	fear: "Mat 10:28,Pro 16:6,3:7,1 Tim 5:20,Psa 111:10,Pro 8:13,9:10;",
	"fear and trembling": "Phil 2:12,2 Cor 7:15;",
	fellowship:
		"Eph 2:5-6,Heb 12:22-23, 1 John 1:3,7,Isa 65:24, Eph 2:5,Eph 3:9,17, 2 Cor 13:14;",
	"few saved": "Luke 13:24-27, Mat 7:13-14;",
	"few words":
		"Mat 5:37, Pro 17:28,29:11,18:21, Mat 12:36-37, James 1:26, 1:19, James 3:6-8;",
	"filthy dreamers": "Jude 1:4,8, 2 Pet 2:14,18,19;",
	firm: "1 Tim 1:19,Heb 3:14,Acts 14:22, Heb 3:6,Luke 21:19;",
	"first day": "1 Cor 16:1-2, Acts 20:7, Rev 1:10;",
	"first priority": "Mat 6:25-33;",
	"five times": "Luke 9:23,14:27,Matthew 10:38,16:24, Mark 8:34;",
	flattery:
		"Pro 20:19,Psa 12:2-4, Psa 5:9,Jude 1:16,Pro 28:23,29:5,1 Thes 2:5;",
	flesh:
		"1 John 2:16,Gal 5:16-17, Rom 8:5,Rom 8:8,9,Eph 4:22,2:3,1 Peter 2:11,4:2,Rom 13:14;",
	follow:
		"Mat 16:24,1 Peter 2:21,Gal 5:17,John 8:12,Mark 8:34,Rom 8:14,John 12:26;",
	food: "Isa 55:1-3,John 6:27,48,50-51, John 6:63,5:40,Mat 4:4, 6:11;",
	"forced repentance": "Pro 1:24-25,27-31;",
	forgive: "James 2:13,Mat 7:1-5,Mat 6:12,14-15,Mat 5:22-26;",
	form: "2 Tim 3:5;",
	formed: "John 6:63,Gal 4:19, 2 Cor 4:10-11,Eph 4:13;",
	"forsake all": "Mat 10:37,Luke 14:33,Mark 10:29-30,Mat 19:29;",
	fountain:
		"Isa 58:11, Jer 2:13,Psa 36:9,John 7:38,4:14,Pro 18:4,14:27,16:22,Rev 21:6,1 Cor 10:4;",
	freed:
		"Acts 26:17-18,1 John 3:9, 5:18,3:6,1 Pet 4:1-2,John 8:32,34,36,Rom 6:18,22,Col 2:11,3:5,Tit 2:13-14;",
	fulfill:
		"Romans 8:4, Romans 3:31,13:10,10:4, Galatians 5:22-24, Galatians 5:14-18, Romans 13:8-10",
	freely: "1 Cor 2:12, Mat 10:8;",
	"friend of Jesus": "John 15:14,John 14:15,23-24, 1 John 3:6,John 10:27;",
	"friendship with the world is enmity with God": "1 John 2:15-17, James 4:4;",
	"fruit of the Spirit": "John 15:5-8,Gal 5:22-23, Mat 12:33,3:10;",
	"fruits of flesh":
		"Mark 7:21-23,Eph 5:3-6,2:3,1 Cor 6:9-10,15:50,Gal 5:19-21,  Rom 8:8,2:8-16,Isaiah 35:8,52:1;",
	"fruits of flesh short":
		"1 Cor 6:9-10,Gal 5:19-21,Eph 5:3,5-6,2:3,15:50,Isaiah 35:8,52:1,Rom 2:15;",
	"fulfills law":
		"Rom 8:4,Rom 3:31,13:10,10:4,Gal 5:22-24,Gal 5:14-18,Rom 13:8-10;",
	fullness: "Eph 3:19,James 1:4, Eph 4:13,Col 4:12,Eph 1:14;",
	"fury of God":
		"Lev 26:27-28,Jer 4:4,Eph 5:5-6, Rom 2:8, Rom 2:9, Pro 1:28-32,Eze 24:13, Jer 30:23,23:19;",
	"give ear":
		"Isaiah 42:23,Isaiah 1:2,Jeremiah 13:15-16,Psalms 78:1,Isaiah 28:23,32:9,Joel 1:2,Deuteronomy 32:1,Psalms 49:1;",
	"glory of believers":
		"Rom 8:30,Col 1:27,2 Cor 4:17,Col 3:4, 2 Cor 3:10, 2 Thes 2:14, Heb 2:10;",
	"God compared to man":
		"Psa 50:21, Heb 7:26, Isa 55:9,65:2,Luke 6:36, Mat 5:48,Pro 15:26, Psa 94:11;",
	"God does not lie":
		"Num 23:19,1 Sam 15:29,2 Sam 7:28,Pro 8:8,Tit 1:2,Heb 6:18;",
	"God is fire":
		"Heb 12:29,Mat 3:11-12,Mal 3:2,1 Cor 3:13,Mark 9:49,Jer 23:29, Isa 33:11,14;",
	"God pleads with all": "Mat 22:14, John 1:7,9,John 12:47-48,Rev 3:20;",
	"God shows no partiality":
		"Deu 10:17,1 Pet 1:16-17,Acts 10:34,Col 3:25,Eze 18:24-26,Pro 24:12;",
	"God wants all men saved":
		"Eze 33:11,Eze 18:30-32,Acts 10:34-35,1 Tim  2:3-4,Rev 3:20, John 3:17,Acts 17: 26-27;",
	godliness:
		"1 Tim 2:10,1 Tim 4:7-8,1 Tim 3:16,2 Pet 1:5-7, 2 Tim 3:5,2 Pet 1:3,1 Tim 2:2;",
	"golden rule": "Mat 7:12, Rom 13:8-10, Gal 5:14, Lev19:18;",
	gospel:
		"Isa 61:1-2,Isa 42:6-7,Luke 4:18-19,Acts 26:18, Luke 1:78-79, John 8:12,Luke 1:77,24:47,Mark 1:15;",
	"gospel of prosperity":
		"1 Timothy 6:5, Ephesians 5:3,5,1 Tim 6:10, Luke 12:15,2 Pet 2:3,14-17,Mark 8:36 ;",
	"gospel short": "Mark 1:15,Luke 4:18-19,Luke 1:77-79,24:47,Acts 26:18;",
	grace: "Jude 1:4-5,8,Tit 2:11-14,1 Pet 1:13,2 Pet 3:18,Eph 1:7,Eph 2:5-6,8;",
	"gropes in the dark": "Psa 82:5,Isa 59:10,John 11:10;",
	grow: "2 Pet 3:18,1 Pet 2:2, 2 Pet 1:5,Eph 4:13;",
	"grow in faith":
		"Jude 1:3,20,2 Pet 1:5, 2 Thes 1:3,2 Cor 10:15,1 Tim 6:12, 1 Thes 3:10, \nHeb 12:2;",
	guided:
		"Psa 32:8,119:105,Luke 1:78-79, Gal 5:18,John 8:12,John 3:21,Isa 30:20-21,Rom 8:14;",
	guide:
		"Psa 32:8,119:105,Luke 1:78-79, Gal 5:18,John 8:12,John 3:21,Isa 30:20-21,Rom 8:14;",
	hate: "1 John 3:15,1 John 4:20,Mat 5:44,Mat 22:39,Pro 25:21-22,1 John 2:9,1 John 2:11;",
	"hate your life": "Luke 9:24,Luke 14:26,John 12:25,Luke 14:33,Gal 5:24;",
	hear: "Prov 8:34,Eph 4:21,Isa 28:23 ,55:3,John 10:27,18:37,6:63,Luke 10:39,42,8:21,Luke 8:18,11:28,,Heb 4:7, 12:25,Rom 10:8,17, Rev 3:20,3:3;",
	heed: "Pro 1:23,33,Psa 119:9,Heb 5:9,3:15,Jer 7:23,Luke 8:18,9:35,Rev 3:3,Mark 4:24;",
	heir: "1 Pet 3:7, 1:4,Rom 8:14,17, Gal 3:26-29,  Col 1:12,Eph 3:6;",
	"high priest": "Heb 2:17-18, 3:1-2,6, 4:11-14, Heb 7:26-27, 8:1-2, 10:20-22;",
	hireling: "John 10:12-13;",
	holiness:
		"2 Cor 7:1,Rom 6:22, Heb 12:10,14, 1 Pet 1:15-17, Isa 35:8,Luke 1:74-75,1 The 4:3-5,7;",
	"holiness and righteousness":
		"Rom 6:19,Luke 1:74-75,Eph 4:24,1 Peter 1:15-16,1 John 3:7-10;",
	"holiness in Old Testament": "EXo 22:31,Lev 11:44-45,Numb 15:40;",
	"honor and glorify God":
		"1 Pet 2:12,Rom 4:20,Mat 5:16,Rom 15:6,John 15:8, Rom 15:16;",
	"honor of men": "John 5:44,12:43,Mat 10:34-38,Luke 14:26",
	hope: "Rom 8:24-25,Heb 3:6,14,1 John 3:2,1 John 3:3,Tit 2:13-14,Col 1:27,1 Peter 1:5-6,9;",
	"hope for all":
		"1 Tim 4:9-10,2:6, Rom 11:32,Luke 3:5-6,Isa 25:6-8,Phil 2:10-11,Col 1:20,1 Cor 15:22;",
	"hope of the hypocrite":
		"Titus 1:16,Mark 7:6, Eze 33:31-32,Isa 28:15, 28:18,Job 8:13,27:8;",
	humility:
		"Luke 18:9-14, Mic 6:8,James 4:6,10,1 Pet 5:5-6,Psa 10:17,Isa 57:15;",
	"hunger and thirst": "Mat 5:6,John 6:35,Isa 55:1-3,John 7:37, John 6:44;",
	hypocrisy:
		"Luke 12:1,Mat 23:2-36,Mark 7:6,Tit 1:16,Ezekiel 33:31,James 1:22;",
	"idolatry is covetousness": "Eph 5:5,Col 3:5;",
	image: "Rev 13:15;",
	"imagination of man":
		"Gen 6:5,Pro 6:16-19,Jer 16:12, 18:12,Jer 7:24,13:10,Jer 11:8,9:14,Jer 3:17, Luke 1:51;",
	immoral: "Pro 6:16-19,Rom 2:15,Eph 5:3-6,Jude 1:4-5,8;",
	imparts:
		"John 10:10 ,John 6:63, John 8:12, 2 Cor 3:6,James 1:21,1 John 5:12;",
	"imprisoned by darkness":
		"Isa 42:6-7,Isa 61:1, Isa 49:6,9, \nPsalms 107:10, 142:7,                \n              1 Pet 3:18-20;",
	impure: "Rev 22:15,Col 3:5,Eph 5:5-6,Rom 1:28,Eph 4:19,2 Cor 12:21;",
	"imputed righteousness": "Rom 3:22;",
	"in Christ": "2 Cor 5:17,1 John 2:5,4:12, Rom 8:1,Gal 5:24;",
	"incline your ear":
		"Psa 78:1-2,45:10,Isa 55:1-3,Jer 34:14,35:15,25:4,Pro 4:20,2:2;",
	"inner law": "Rom 2:14-16, Rom 7:1,7,12, John 12:48;",
	"inward cross of self-denial":
		"Mat 16:24-25,1 Cor 1:18,1:17 ,Gal 5:24,Gal 2:20,6:14,2 Cor 4:10-11, Phil 3:18-19,Luke 14:27;",
	"inward faith":
		"Rom 10:8,Rom 10:17,1:19,John 18:37,10:27,8:47,6:63,Eph 4:21,Gal 3:2,5;",
	"inward man":
		"Psa 51:6,Rom7:22,1:19,Psa 51:2,7,10,Eph 3:16-20,2 Cor 4:16,Jer 31:33,Rom 2:29;",
	"inwardly ravened":
		"Luke 11:39, Mat 7:15,Acts 20:29-31,Mat 23:25-28, Jude 1:4,16-19;",
	"irrelevant doctrines": "1 Tim 1:4,6, Eph 4:9,Mark 7:8;",
	"itching ears": "1 John 4:5, 2 Tim 4:3-4,Rev 17:2;",
	"Jesus accused": "John 10:20,36,Mat 12:24-27, Mark 3:22,30, Luke 11:15;",
	"Jesus beaten":
		"John 19:2-3,Mat 26:65-67,Mat 27:27,30,Isa 52:14,Mark 14:65,15:16-19;",
	"Jesus blood": "Heb 9:14, Heb 10:22, 1 John 5:8;",
	"Jesus called a blasphemer":
		"John 10:31-33,Mark 3:22,30,Mark 3:5-6,Mat 9:2-3, Mat 26:65;",
	"Jesus calls to repent":
		"Luke 5:32,13:3,5,Mark 7:21-23,Mark 9:43,45,47,48,John 8:11,5:14,Eze 18:30-32,Rev 3:3;",
	"Jesus claimed":
		"John 20:17, John 14:28,John 10:36,Luke 22:70, Mark 14:61-62;",
	"Jesus commanding to repent":
		"Mat 4:17, Luke 13:3,5,Mark 9:43,45,47,48,John 8:11,5:14,Rev 3:3,19, Mark 1:15, Mat 3:2;",
	"Jesus demands works": "Rev 2:2,9,Rev 2:13,19,26-27,Rev 3:1-2,19,Rev 3:8,15;",
	"Jesus false prophets warning":
		"Mat 7:15,Mat 15:14,Mat 24:11,Mat 24:24,Mark 13:22, Luke 6:39-40,Luke 21:8;",
	"Jesus Only as Instructed": "John 12:49-50,8:26,7:18,John 5:19,30,14:31;",
	"Jesus preaching soon":
		"Mark 1:14-15, Rev 22:7,12,20,Mat 4:17,10:7, Rev 2:5,16, Luke 16:16, Mat 21:31, Rev 2:25, 3:11, Mat 11:12;",
	"Jews demanded Jesus be crucified": "Mat 27:22-25;",
	"Jews had scriptures": "John 8:37,John 5:37-38,John 5:39-40, John 8:47;",
	joy: "John 15:11,16:24, John 17:13,John 16:20-21,Rom 14:17,Gal 5:22-23,1 Pet 4:13,1 John 1:4;",
	"joy of the Lord": "John 15:11,John 17:13, Mat 25:21, John 16:24;",
	"judging others": "Rom 14:10,13, Mat 7:1,1 Cor 11:31,Luke 6:37;",
	judgment:
		"1 Pet 4:17,Mat 12:20,Rev 14:7,16:7, Pro 24:12,2 Cor 5:10, James 2:13, 2 Pet 2:9;",
	justification: "James 2:24,26,Rom 3:28,Gal  2:17,5:6,Rom 2:13-15;",
	keep: "John 14:23-24,John 8:51,Pro 7:1, Rev 3:3,1 John 3:22,John 12:47-48;",
	kind: "Gal 5:22, Eph 4:32, Col 3:12, 2 Cor 6:6,1 Cor 13:4.",
	"know all things": "John 14:26,1 John 2:20, 1 John 2:27,John 16:13;",
	"know God":
		"1 John 3:6, Tit 1:16, Rom 1:19,10:8,Mat 11:27, John 5:37, John 10:14-15;",
	"know truth": "John 16:13, 8:32,Eph 4:17-21,1 John 2:27;",
	"Known by the Lord":
		"Mat 25:11-12, John 10:14-15,27, Mat 7:22, Mat 7:23, Luke 13:25, Luke 13:26-27;",
	"law has dominion until death": "Rom 7:1,6,9;",
	"law is your schoolmaster": "Rom 7:1,7,12,Galatians 3:24-25,Gal 5:18,19-21;",
	lawlessness:
		"1 John 3:4, Mat 13:41-43,Mat 7:23,Jude 1:4,2 Tim 2:19,21, 2 Thes 2:7;",
	learning: "Pro 1:5-6,Mat 11:29-30,Wis 9:14-19,4 Esdras 9:11-13,Pro 16:23;",
	led: "Rom 8:14,Gal 5:18;",
	letter: "2 Cor 3:6,Rom 7:6;",
	liberty: "2 Cor 3:17, Gal 5:1,18, James 1:23-25,Rom 8:2,21,James 2:12;",
	"life of flesh": "Rom 8:8, Rom 8:13,Eph 4:17-21,Eph 2:3,Rom 8:5,Mat 10:39;",
	"life of God":
		"John 6:33,35,John 1:4,11:25,John 14:6,5:40,John 10:10,John 6:63,12:25,John 8:12,2 Cor 3:6;",
	"light and word within":
		"John 1:1,4,John1:7,9,Rom 10:8,17,Deu 30:10-14,Col 3:16,Eph 4:21;",
	"light arises":
		"Psa 112:4,18:28,Isa 58:7-10,34:5,2 Pet 1:19,Luke 1:78-79,Mat 24:27,Eph 5:8,Job 25:3;",
	"light of the day":
		"1Thes 5:5,8,Ecc 11:7,2 Pet 1:19, John 9:4,1 Cor 3:13, Pro4:18,Rom 13:12;",
	"lip service":
		"Mark 7:6,Tit 1:16,Mat 15:8,Eze 33:31-32,John 14:24,1 John 3:6,James 1:22;",
	listen:
		"Deu 30:10-14,Isa 55:2-3,Pro 1:33,7:24,2:2,Luke 6:47-49,Jer 7:23,16:11-12,Pro 4:20, 2:6,1:23,Acts 3:22-23, Psa 78:1-2;",
	"listen to Lord for ability to obey laws":
		"Exo 19:5,Deu 30:10,Deu 28:1-2,1 Sam 15:22,Job 36:10-11,Jer 7:23,Jer 11:7;",
	"little children": "Mat 18:3, Mark 10:14-15, Luke 18:16,Mat 19:14;",
	"live in you": "Gal 4:19, John 14:23, Rom 8:9-10;",
	"living for lusts and pleasures": "1 Tim 5:6,Rom 8:5,Eph 2:3,Gal 5:24;",
	"long robes prayers": "Mat 23:2-10 ,Luke 20:46-47,Mark 12:38-40;",
	longsuffering:
		"Eph 4:2,Col 1:10-11,Gal 5:22, 2 Cor 6:4-6,1 Cor 13:4,Col 3:12, 2 Tim 3:10;",
	"lose life":
		"Mat 16:25,John 12:25,Mark 8:35, Mat 10:39,Luke 17:33,2 Tim 2:11,Luke 9:24,Rom 12:1, Rom 7:9;",
	love: "1 Cor 13:4-8;",
	"love enemies": "Luke 6:27-35, Rom 12:17-21, Mat 5:44-48;",
	"love of God": "John 14:15,23,24,Pro 8:34,Isaiah 64:4,1 John 5:2-3,2:5;",
	"love of God perfected": "1 John 2:5, 1 John 4:12, Eph 3:16-20,John 17:26;",
	lust: "1 John 2:16,Gal 5:16-17,1 Thes 4:4-5,7, 1 Cor 6:18,1 Pet 2:11,4:2,2 Tim 2:22,Rom 8:13:14,Eph 2:3,Tit 3:3,Eph 4:22;",
	lying:
		"Col 3:9,Luke 3:14,Pro 19:22,12:19,22,Mark 10:19,Rev 21:8, Lev 19:11,Psa 7:14,58:3, Isa 63:8;",
	"man of sin": "2 Thes 2:3-4,8;",
	mark: "1 Tim 1:5-7,1 Tim 6:20-21, Heb 4:1;",
	"mark of the beast": "Rev 13:16-17;",
	mediator: "Heb 8:6-8,10-12 ,1 Tim 2:5, Heb 12:24,1:3;",
	Meekness:
		"Num 12:3,Psa 25:9,37:11,Mat 5:5, 11:29,21:5,Psa 76:9,149:4,Gal 5:22-23,Jam 1:21;",
	"men speak evil": "Mat 5:37, James 1:26,Mat 12:36-37,James 3:2,5-8;",
	"merchants of Babylon": "Rev 18:3,11;",
	mercy: "James 2:13,Mat 5:7,Luke 6:36,Psalm 85:10,33:22,Mic 6:8,,Mat 12:7;",
	"mind of Christ":
		"Rom 12:2,Eph 4:22-24,Phil 2:5,1 Cor 2:16,Heb  8:10, 2 Cor 10:5;",
	"ministry of condemnation": "2 Cor 3:9;",
	"ministry of righteousness": "2 Cor 3:9, Rom 8:1,2 ;",
	modesty:
		"1 Cor 13:4, Psa 5:5,1 Tim 2:9,1 Pet 4:3,Rom 13:13,Eze 16:49,Eph 5:18;",
	money:
		"1 Pet 5:2,Mat 10:8,John 10:11-13,Isa 55:1-2,2 Cor 2:17,1 Cor 9:18,1 The 2:5,2 The 3:8-10,2 Pet 2:3;",
	"money Old Testament":
		"Mic 3:11,Isa 56:11,Eze 34:2,10,2 Kings 5:15-16,2 Kings 5:20,22,26,27,Jer 5:31,Mic 3:5;",
	"moral core": "Mat 19:16-21,Rom 2:14-16, Rom 7:1,7,12;",
	"more spirit given":
		"Proverbs 1:23,33,Pro 13:18, Acts 5:32,Mark 4:24,Luke 8:18;",
	"morning star": "Rev 2:28,Rev 22:16,2 Pet 1:19,Mat 24:27,Luke 1:78-79;",
	mortify:
		"Rom 8:13,Col 2:11,Col 3:5,8,Eph 4:22,Gal 5:24,1 Pet 2:21,4:1-2,1 John 3:8;",
	"my word":
		"Rev 3:8,10, Numbers 11:23,20:24,Isa 55:11, Isa 66:2,Jer 1:12,5:14,6:19,Jer 23:28-29, John 8:31,37,43;",
	name: "Pro 18:10,Mal 3:16,John 1:12, Isa 50:10,Psa 63:5-6,Isa 26:3,8;",
	"name in vain": "Exo 20:7, Mat 15:9;",
	"narrow way":
		"John 14:6, Mat 7:13-15, Luke 13:23-24, Isa 35:8-10, Acts 14:22;",
	"natural light debunked": "Rev 21:22-24, Isa 60:19, Psa 139:12;",
	near: "Jer 23:23,Deu 30:10-14, Acts 17:26-28,Psa 119:151,145:18,Isa 55:6,50:8,James 4:8;",
	"never fall": "2 Peter 1:4-11;",
	"new covenant":
		"Acts 26:23,17-18, Luke 1:78-79,2:32,Heb 8:8,10,Isa 42:6, 49:6, John 8:12,John 12:46;",
	"new creature": "2 Cor 5:17,Gal 6:15,Col 3:10,Eph 4:23-24,1 Cor 15:53,6:17;",
	"new earth":
		"2 Pet 3:12,2 Pet 3:13-14,Rev  21:1,5,Isa 65:17,1 John 2:17,Mat 28:20, 1 Cor 10:11,2 Cor 5:17,Rom 6:4;",
	"new heart":
		"Mat 3:11-12,Jer 32:39-40,24:7,Rom 2:29,12:2,Eze 18:31-32,36:26,11:19,Psa 51:2,7,10,James 4:8-10;",
	"new song": "Isa 12:2,26:1, 52:8,Rev 14:1-3,Rev 15:1-3,5:9;",
	"newness of life": "John 10:10,Rom 6:4, Rom 7:6,2 Cor 5:17;",
	"no fruit - fire": "John 15:6, Mat 7:18-20, Mat 12:33,Mat 3:10,John 15:1-2;",
	"no pleasure in your death": "Eze 18:30-32, Eze 33:11;",
	obey: "Acts 5:32,Luke 9:35, Heb 5:9,1John 2:3, 5:2-3,John 14:15,23-24,15:14,10,Rom 6:16,Jer 7:23,1 Pet 1:22,Acts 3:22-23, Rev 3:3;",
	obedience:
		"Acts 5:32,Luke 9:35, Heb 5:9,1John 2:3, 5:2-3,John 14:15,23-24,15:14,10,Rom 6:16,Jer 7:23,1 Pet 1:22,Acts 3:22-23, Rev 3:3;",
	offended: "Mat 13:20-21, Mark 4:16-17, Luke 8:13,15;",
	"One God":
		"Eph 4:5-6,John 20:17,John 14:28,1 Cor 8:6,1 Tim 2:5,1 John 5:7,1 Cor 15:28, 2 Cor 11:31, Eph 1:3,17,1 Pet 1:3;",
	"One Lord":
		"Eph 4:5,John 5:23,1 Cor 8:6, 1 Tim 2:5, Col 1:13,15-19,Phil 2:6,Rev 4:11;",
	"one spirit not three persons": "John 10:30,1 John 5:7;",
	"one thing needed": "John 18:37,10:27,Luke 10:39,41-42,Deu 33:3,John 6:63;",
	"one wife": "1 Tim 3:2,12, 1 Tim 5:9,Tit 1:6, Mark10:11-12,Mat 19:9;",
	"only call Him Lord":
		"Mat 25:11-12,26:47,49,Luke 6:46,Luke 13:25-27,Mat 7:21-23,Mat 15:8;",
	"only the pure go to heaven":
		"Eph 5:5-6,Gal 5:19-21,Mark 7:21-23,Rev 21:23,27,Isa 35:8;",
	"operational faith": "Gal 5:6,James 2:20-24,John 3:21;",
	"out of darkness": "John 8:12, 12:46, Acts 26:17-18,1 Pet 2:9, Col 1:12-13;",
	"outer darkness": "Mat 8:12,Luke 9:25,Mat 25:30,Mat 22:13;",
	overcome:
		"1 John 2:13,14,1 John 4:4,5:5,4,Rev 12:11,3:5,10,21,Rev 2:7,17,2 Peter 1:4;",
	"overcome sexual desire":
		"1 Cor 7:5-7,Luke 20:34-36,Mat 19:11-12,14,1 Pet 3:5-8,Rev 14:3-5,Mat 22:28-30,Mat 18:3;",
	pain: "Pro 20:30, Heb 12:4,6,8, 1 Pet 4:12,\n1 Pet 4:1-2, Eph 6:16, 4 Esdras 9:11-13;",
	"parallel dimension": "Acts 17:26-28,Luke 17:20-21,Eph 4:6;",
	partake: "2 Pet 1:4,Col 1:12,Heb 12:10,3:14,Eph  3:6,1 Pet 5:1,Heb 2:11;",
	partiality: "James 2:9,Pro 28:21,Acts 10:34,Lev 19:15;",
	partying:
		"Rom 13:13,1 Peter 4:3,Exodus 32:5-7,Gal 5:19-21,Ecc 7:4,1 Thes 4:11;",
	patience:
		"1 Tim 6:11,Rev 1:9,Heb 6:12,12:1,James 5:11,1:4,Rom 5:3-4,Gal 5:22-23,Rom 8:25;",
	"patient waiting":
		"Psa 37:7, Rom 8:25,2 Thes 3:5,Heb 9:28,Gal 5:5,James 5:7,Psa 40:1;",
	"Paul was perfect":
		"Gal 1:15-16,Gal 2:20,Col 1:13,Eph 2:6,1 Tim 5:21,2 Cor 2:17,4:2,2 Tim 4:1;",
	"peace from God":
		"Gal 6:15-16,Luke 1:79,Isa 32:17,Phil 4:7,Isa 26:3,Col 3:15,1 Pet 3:11,Eph 4:3,2:14,Rom 2:10;",
	"peace with others": "Heb 12:14, Rom 12:18; 1 Thes 4:11;",
	"penalty for not obeying the voice of the Lord":
		"Deu 8:20, Deu 28:15-57,Deu 28:62,Deu 18:15,19,Hos 9:17,Jer 6:19,18:10-12, Jer 9:13-16,Jer 12:17,11:8,14, Eze 20:8;",
	perfect:
		"Mat 19:16,21,2 Cor 13:11,7:1,1John 2:5,4:12,Col 1:28, 4:12,Heb 6:1,10:14,13:21,Mat 5:48,John 17:23,Eph 4:13,4:11-12,Luke 6:40,James 1:4;",
	"perfect and complete": "Col 4:12, James 1:4;",
	"perfect in Old":
		"Gen 6:9,Gen17:1,Deu 18:13,1 Kings 8:61,11:4,2 Chron 16:9,2 Chron15:17, 19:9,,2 Kings 20:3, 2 Sam 22:33,Job 1:8, 9:21,2:3,Psa 18:32, 119:96,37:37,101:2,6;",
	perishing: "2 Cor 4:3, 1 Cor 1:17-18,Phil 3:18-19;",
	persecution:
		"Luke 11:49,1 Cor 4:12, John 15:20,Mat 5:10-12,44,Rom 8:35,12:14,2 Tim 3:12, Gal 4:29, Mark 10:30,  2 Thes 1:4;",
	persevere:
		"Heb 3:14,Heb 6:11-12,Mat 7:8,Heb 9:28,Luke 8:15,1 Pet 1:6,9,1 Tim 5:5,Rev 2:3;",
	Pharisees:
		"Luke 11:43,46-48, Luke 20:46-47,11:39 ,Mat 23:7-10,Mat 23:13-15,Mat 23:3,27-28;",
	plagues: "Rev 11:6,Rev 15:1,6,8,Rev 18:4,8,Rev16:9, Rev 21:9;",
	pleasure:
		"Luke 8:14,1 John 2:15,James 5:5,Pro 21:17, Tit 3:3,1 Timothy 5:6, Gal 5:24;",
	"power of God":
		"Col 1:28-29,Rom 1:16,1 Cor 1:24,1 Cor 1:18,Eph 3:20,Eph 3:19,16,John 1:12,2 Timothy 3:5;",
	"power short": "Rom 1:16,1 Cor 1 :18, 1 Cor  1:24,  2 Tim 3:5;",
	"pray only in the Spirit":
		"Job 37:19, Eph 6:18-19,1 John 5:14-15,Romans 8:6-7;",
	"preachers not sent by God":
		"Eze 13:2-3,10,22,Mic 3:5,10,Jer 14:14,Isa 56:10-11,Jer 23:16-17,Jer 23:21-22,25-32;",
	presence:
		"John 12:26,1 Tim 5:21,2 Cor 2:17,4:2,2 Tim 4:1, Eph 2:6 ,1 Chr 16:11, Jude 1:24;",
	pride:
		"Mark 7:21-22,1 Cor 13:4-5,Pro 16:18,29:23,6:16-19,Pro 11:2,8:13,14:3,1 John 2:16,Job 35:12,Rom 6:8,Eze 16:49;",
	"priorities from Jesus": "Mat 6:33, Luke 10:39,42;",
	"prisoner of the Lord": "Eph 3:1; Phil 1:1,23,2 Tim 1:8;",
	"prize your time": "James 4:14,Eph 5:16,Isa 55:6,Psa144:4; Psa 39:5;",
	"progression of thoughts to peace":
		"Psa 50:21,Isa 55:7-9,Rom 8:7, Eph 4:22-24, 2 Cor 10:5, Phil 4:7,Phi 2:5;",
	"proper worship": "1 Cor 2:13,1 Cor 14:29-31,Col 3:16,1 Pet 4:10-11;",
	protected: "1 John 3:9,1 John 5:18,John 10:29,John 17:15,Heb 10:14;",
	"pure heart":
		"Mat 5:8, 1 Pet 1:22,Acts 15:9,Acts 26:18,James 4:8-10, Psa 24:3-6,Tit 2:13-14, 2 Tim 2:22;",
	purge: "Pro 16:6,20:30,Mat 3:11-12,2 Tim 2:19-22, Eze 24:13;",
	purify:
		"Mat 5:8,Acts 15:9,James 4:8-10,Acts 26:18,1 Pet 1:22,1 John 3:3,Tit 2:14, Dan 12:10, Mal 3:2-3;",
	"purify in Old Test":
		"Pro 21:8,22:11,Psa 24:3-5,Psa 73:2,18:26,Pro 15:26, Dan 12:10, Isa 1:25;",
	"purpose of a Christian":
		"Phil 2:13,Titus 2:14,Eph 2:10,Mat 5:16, Heb 13:20-21,Rom 6:13;",
	"purpose of life": "4 Esd 9:13,Acts17:26-28;",
	"put off": "Col 3:5,8-9, Col 2:11, Eph 4:22;",
	rage: "Pro 14:16,Gal 5:19-21,Pro 29:9;",
	rapture: "1 Thes 4:16-17;",
	reconciliation: "Col 1:20, Rom 5:18, 1 Tim 4:10,1 Tim 2:6,1 John 2:2;",
	redemption:
		"Eph 1:14,Eph 4:30, Rom 8:23,Col 1:12-14,Tit 2:13-14,Luke 21:26-28;",
	"rejoice always": "Rom 12:12,Phil 4:4,2 Cor 6:10;",
	"remember not your sins":
		"Isa 43:25,Heb 8:12,Heb 10:17,Jer 31:34,Eze 33:15-16;",
	"renewed mind":
		"Rom 12:2, 8:6-7,Isa 65:2, 55:7-9,Eph 4:22-24, 2 Cor 10:4-5,Phil 2:5,1 Cor 2:16;",
	repent:
		"Luke 13:3,5,Rev 3:3,19,Mark 9:43,45,47-48,Luke 3:8-14,John 8:11,5:14,Rom 2:4,Eze 18:30-32,2 Cor 7:10;",
	reproach:
		"2 Cor 12:10,2 Cor 2:15-16,1 Tim 4:10,Gal 5:11,1 Cor 1:18, Heb 10:33, 11:26, 1 Pet 4:14, Luke 6:22;",
	reprove:
		"Eph 5:13,John 16:8-10,John 3:16,John 3:19-20,Rev 3:20,Tit 2:11-12,Pro 1:23-33, John 12:47-48,Pro 13:18;",
	requirement:
		"Luke 9:24, Romans 8:13, Colossians 3:5-6, Ephesians 4:22-24, Galatians 5:24,2:20, 1 Peter 1:6,9, Matthew 16:25, John 8:31-32,34,36",
	requirements:
		"Luke 9:24, Romans 8:13, Colossians 3:5-6, Ephesians 4:22-24, Galatians 5:24,2:20, 1 Peter 1:6,9, Matthew 16:25, John 8:31-32,34,36",
	rest: "Mat 11:28-29,Heb 4:1,10-11,Isa 28:12,11:10,30:15;",
	restored: "Col 3:10,Eph 4:13,Eph 4:22-24,John 8:12,John 10:10,Luke 6:40;",
	resurrected:
		"Col 2:12,3:1, Eph 2:6, John 5:25, Rom 6:13,2 Cor 4:14, Phil 3:10-11;",
	revelations:
		"Mat 11:27,Rom 1:19,1:17,Eph 3:3,5:13,Gal 1:11-12,2 Cor 12:1-2,4,Psa 90:8,50:21;",
	righteousness:
		"Rom 6:16,19,1 Cor 15:34,1 John 3:7-9,Mat 5:6,Mat 6:33,2 Tim 2:22,Gal 5:5,Eph 4:22,24,5:5-6;",
	rock: "Deu 32:4,18,1 Cor 10:4,Rom 9:33;",
	royal: "Rom 13:10,Eph 5:2-7,Gal 5:14,22-23,James 2:8",
	"royal law of love": "Rom 13:10,Eph 5:2-7,Gal 5:14,22-23,James 2:8",
	"rule heart": "Eph 3:17,Col 3:15,Rom 8:9,1 Pet 4:11,2 Cor 10:5,Heb 13:21",
	"run ahead": "Jer 23:21,2 John 1:9,Gen 10:9;",
	"Saints refs in Old Testament":
		"1 Sam 2:9,2 Chron 6:41,Psa 31:23,37:28,Psa 52:9,50:5,Psa 16:3,34:9,Mat 27:52,Pro 2:8;",
	salvation:
		"1 Pet 1:6,9,Mat 1:21,1 John 3:8,Phil 2:12,Heb 5:9,Heb 9:28,1 Pet 2:2,2 Cor 7:10;",
	"salvation conditions":
		"1 John 3:7-10, Mat 5:48, Luke 6:36, luke 9:23-24,14: 33,Hebrews 12:14,1 John 3:3,1 Pet 1:15-16,1 John 2:6, 1 John 4:17;",
	"salvation exclusions":
		"Luke 13:3,5,Eph 5:3,5-6,Mark 7:21-23,Mark 9:43,45,47-48 ,Rom 8:8,13,Galatians 5:19-21,1 Cor 6:9-10, 1 Cor 15:50,Rev 21:27;",
	"salvation is not instant":
		"Rom 13:11,Phil 2:12,1 Thes 5:8,1 Cor 1:18,2 Cor 7:10,1 Pet 1:5-9, 1 Pet 2:2, Eph 4:30, 2 Cor 2:15,Heb 3:14,Heb10:36,Heb 6:11-12;",
	"salvation requirements":
		"Luke 9:24,Rom 8:13,Col 3:5-6,Eph 4:22-24, Gal 5:24,2:20,1 Peter 1:6,9,Mat 16:25,John 8:31-32,34,36;",
	"salvation short": "Heb 5:9,Tit 2:11-14,Heb 9:28;",
	"salvation works": "Gal 5:6,Rom 8:13,Phil 2:12,James 2:20,24,Col 3:5;",
	sanctified: "John 17:17,John 17:19,Eph 5:25-26,Heb 10:14,Heb 2:11;",
	"Satan in men":
		"Luke 9:53-55,Mat 5:37,16:23,Eph 2:2-3,1John 3:8,Acts 26:17-18;",
	scatter: "Luk 11:23, Mat 12:30;",
	"scriptures words":
		"Exo 20:1,John 5:37-40,John 10:35, Rev 22:18,Daniel 9:2,Mat  24:35,Acts 17:11;",
	sealed: "2 Cor 1:21-22,Eph 1:12-13,Eph 4:30,2 Cor 5:5,Acts 5:32;",
	"secret sins":
		"Rom 8:27, Rev 2:23,Jer 17:10, 1 Chron 28:9,Luke 2:35,Psa 90:8,Ephesians 5:13,1 Cor 4:5, Heb 4:12;",
	see: "John 6:40,John 17:24,John 14:21-23,Mat 5:8,2 Cor 4:6,2 Cor 3:18,1 John 3:2,Rev 22:4-5,Isa 30:20;",
	"see by the light":
		"Isa 60:19,Col 1:12,Psa 32:8,Rev 21:22-24,Isaiah 58:8,10;",
	seed: "Luke 8:11,1 Pet 1:23,25,1 John 3:9, Gal 3:19;",
	seek: "Heb 11:6,Deu 4:29,30:10,1 Chr 16:11,Mat 6:33,Acts 17:27,Pro 8:17, Lam 3:25,Jer 29:13-14,Mat 7:7-8;",
	"seek the living among the dead": "Luke 24:5, Pro 21:16;",
	"seek with all your heart":
		"Deu 4:29,Mat 6:33,Deu 30:10-14,Prov 8:17,Isa 45:19;",
	"self-righteous":
		"Luke 11:34,1 John 3:7,1 John 3:8,Rev 3:17-18,Gal 5:5,Luke 5:32,John 9:39,41;",
	sent: "Mat 9:38,Rom 10:15,John 7:18,John 7:6,8,2:4,Jer 23:21-22,Jer 14:14;",
	"seriousness of sin": "Mat 18:8-9,Mark 9:43,45,47-48,Mat 5:28-30;",
	serpents: "Mat 23:29,33,Mat 12:34,Luke 3:7,Mat 3:7;",
	servant:
		"Mat 10:24-25,Mat 24:45-47,Luke 12:47,Luke 16:13,John 13:13-16,John 15:20;",
	"serve God":
		"Heb 9:14,Luke 1:74-75,Heb 12:28, John 12:26,Rom 6:22,  Rev 22:3, Rev 7:15;",
	"set sins before you": "Psa 90:8, Psa 50:21,Eph 5:13;",
	"seven trials": "Pro 24:16, Psa 12:6,Rev 5:1,Lev 26:28, Job 5:19, Rev 15:7;",
	"sexual immorality":
		"1 Cor 6:18,Mat 5:28-29,Eph 5:3-4,Eph 5:5-6,Gal 5:19,21,1Thes 4:3-5,7,Heb 12:16,Rom 13:13,Acts 15:28-29;",
	"shadow of death":
		"Job 28:3,10:22,16:16,Psa 23:4,44:19,107:10, Mat 4:16, Luke 1:79;",
	shadows:
		"Heb 10:1-3,14, Col 2:16-17,Heb 8:4-5,Heb 7:12,18-19,28,Heb 8:6,9:24;",
	"short truth": "John 14:6,1 John 2:26,27, Eph 4:21;",
	"shown by the light":
		"Eph 5:13, Psa 90:8, 50:21, Luke 2:35,1 Cor 4:5,1 Chron 28:9;",
	silence:
		"Mat 6:7-8,Zec 2:13,Zep 1:7,Psa 46:10, 62:1,Job 37:19,Hab 2:20,Ecc 5:2-3;",
	"sinners destroyed":
		"Psa 37:7,9-10,38,Psa 110:6, Pro 2:22,Isa 24:6,Isa 1:28,13:9,Isa 26:21,Isa 28:22,Jer 25:29;",
	"sins of whole world": "1 John 2:2,Rom 5:18-19,1 Tim 2:6,John 1:29,Heb 2:9;",
	sit: "Luke 10:39,42,Deu 33:3,Lam 3:26,28;",
	"sit in darkness":
		"Isa 42:6-7, Mat 4:16,Luke 1:78-79,59:9,Psa 107:10,142:6-7,Micah 7:8;",
	"sitting in the heavens": "Eph 2:5-6, John 17:15,24;",
	"six attestations":
		"Mat 16:28,Mark 8:9:1,Luke 9:27, Mat 24:29-34,Mark 13:24-30,Luke 21:27-32;",
	"slave to righteousness": "Rom 6:16-19, 1 John 3:7-10;",
	"slave to sin": "John 8:34,Rom 6:16,1 John 3:8;",
	sleep:
		"Pro 6:4,9-11,Pro 24:33-34,Pro 20:13,Rev 3:2,1 Thes 5:6,Eph 5:14,Rev 16:15,Psa 63:6;",
	"small still voice": "1 Kings 19:9-13;",
	"some standing": "Mat 16:28,Mark 8:9:1,Luke 9:27;",
	"son of God requirements":
		"Rom 8:17,Rom  8:14,Heb 12:5-8,Phil 2:12-15,1 John 3:2-3, 1 Thes 5:5,8;",
	"soon in Revelation":
		"Rev 22:20,Rev 2:16,Rev 22:12,Rev 2:25,Rev 22:7,Rev 3:11,Rev 2:5;",
	"soon James": "James 5:7, James 5:8;",
	"soon John": "1 John 3:2-3,1 John 2:18,1 John 2:28,1 John 3:8 ,1 John 4:3;",
	"soon Jesus":
		"Mark 1:14-15,9:1, Mat 10:7,16:28, \nMat 4:17,5:3, Luke 16:16,9:27, \nMat 11:12,5:10, Mat 21:31;",
	"soon Paul":
		"Phi 4:5,1 Cor 7:29,4:5,Tit 2:13,Rom 16:20,1 The  2:1,19,1 The 1:10,4:15,2 Cor 4:6, 3:18,1 Cor11:26,1 Tim 6:14;",
	"soon Peter": "1 Pet 4:7,2 Pet 3:12,2 Pet 1:16,1 Pet 1:5-7, 1 Pet 4:12-13;",
	soul: "Mat 10:28,Luke9:24-25,Luke 21:19;",
	sower: "Mark 4:14-20,Mat 13:18-23,Luke 8:11-15;",
	"spirit and truth": "John 4:23-24;",
	"spirit in heart":
		"John 14:16-18,15:26, 16:13-14, 2 Cor 1:21-22, Rom 8:12-15,2 Cor 5:5,Gal 4:6;",
	"stages of perfection": "Gal 5:24;",
	"stand apart from the world":
		"1 Peter 2:11,1 Peter 1:1, 1 John 2:15-16,1 Cor 7:31,Romans 12:2,1 Peter 4:3,Ephesians 4:17,24;",
	"stand fast":
		"Phil 4:1, 2:16,1 Thes 5:21, 3:8,Heb 10:23,3:6,Rev 3:3, 2:13, 3:11,2:25, 1 Pet 5:9,1 Cor 15:2,Phil 1:27,Gal 5:1;",
	steadfast: "Luke 8:15, James 1:3-4, 2 Thes 1:4,Rom 5:3-4, Luke 21:19;",
	"steps of faith": "Rom 4:12,20;",
	still: "Psa 37:7,9,Psa 46:10 ,1 Kings 19:12 ,Psa 4:4;",
	"still sinning":
		"Rom 8:8, John 8:34,Rom 8:13,1 Tim 5:20,Mark 9:43,45,47,48,James 4:8-10,Rom 2:9,Eph 5:5-6,1 John 3:8,1 Cor 15:34;",
	"still walk the earth":
		"John 12:26, John 14:3, John 17:24,John 17:15, 2 Cor  6:16;",
	"strengthened law": "Mat 5:20-48;",
	strife:
		"2 Tim 2:24,Tit 3:9,Phil 2:3,Heb 12:14,1 Cor  3:3,1 Tim 6:4-5, Rom 16:17, 12:18, James 3:16;",
	strive: "Luke 13:24-27,2 Pet 1:5-8,Heb 4:11;",
	suffer:
		"1 Pet 4:12-13, 2Tim  2:12,2 Tim 3:12,2:11, 1 Pet 4:1-2,1 Pet 1:6-7,1 Pet 2:21,4:19,Heb 12:6;",
	swear: "Mat 5:33-37,James 5:12;",
	"sword of the spirit":
		"Heb 4:12,Eph 6:17,Rev 1:16,2:16,2 Thessalonians 2:8, Rev 19:13,15,21;",
	"sword turned backward": "Isa 59:14;",
	"take no thought": "2 Cor 10:5,Mat 6:25,31,34,Luke 12:11-12;",
	"taught by God":
		"John 16:13-14,14:16-18,26,6:45, 1 John 2:20,27,John 6:45,Psa 32:8,25:8-9,Mat 11:29-30,Tit 2:11-12,Eph 4:21;",
	"taught by Jesus":
		"John 14:26, 16:13, Mat 11:29-30,Eph 4:20-21,John 6:45,1 John 2:27,Mat 23:10;",
	teacher:
		"Psa 32:8, 25:8-9,Mat 23:10,1 John 2:20,27,John 14:26, 6:45, John 16:13, Isa  30:20,Isa 48:17,54:13;",
	"testimony forbidden":
		"Mat 8:4,12:16,17:9,Mark 8:30,1:44,3:12,7:36,9:9, John 2:25, Luke 5:14,8:56,9:21;",
	"the word and scripture in same verse":
		"Dan 9:2,John 5:38-40,John 10:35,Acts 17:11, John 2:22,;",
	"the word is a living being":
		"Psa 33:6, Rev 19:13-16,John 1:14, 2 Peter 3:5-7,1 Peter 1:23,25, Heb 11:3, John 1:1-2;",
	"thoughts from man":
		"Eph 4:17,Psa 94:11,Prov 15:26,Isa 55:7, Eph 2:3,Isa 65:2,55:8-9,Jer 16:12, 31:33,Gal 5:17;",
	"thoughts from the Spirit":
		"2 Cor 10:5,1 Cor 2:16,Heb 8:10,Eph 4:22-24,Rom 12:2;",
	tithes: "Heb 7:12,18-19;",
	"transfer meaning of salvation":
		"Eze 13:22,Eph 5:5-6,Jude 1:4,2 Pet 2:19, 2 Tim 4:3-4,2 Pet 2:1-2,Rom 16:18;",
	translated:
		"John 12:26,Luke 17:20-21,Col 1:13,John 14:3,17:24,Eph 2:5-6,Rev 1:9,Heb 12:22-23;",
	"tree of life": "Gen 2:9,3:24,Rev 2:7,Rev  22:14,Pro 11:30,13:12;",
	tremble:
		"Psa 119:120,Isa 66:2,Phil 2:12,Heb 12:21,Hab 3:16,Exodus 20:18,Psa 96:9,Jer 5:22,James 2:19;",
	"trial by fire": "1 Pet 1:5-7,1 Pet 4:1-2,12, James 1:2-4,12;",
	"trials of faith":
		"1 Pet 1:5-6, 1 Peter 1:7,9, Acts 14:22, \n1 Peter 4:12 , Heb 12:6-8, \nJames 1:2-3,12, 1 Pet 4:1-2,19 ;",
	tribulation:
		"1 Pet 4:12,2:21,1 Pet 1:6-7,Acts 14:22,1 Pet 4:1-2,James 1:2-4,12,Mat 13:20-21;",
	trinity: "1 John 5:7, Mat 28:19;",
	"true peace": "Isa 32:17,Phil 4:7,Isa 26:3, Col 3:15;",
	"true treasure":
		"Pro 16:16,Pro 8:10,Mat 6:19-20,Luke 12:33,Pro 8:19,Mark 8:36,1 Timothy 6:5;",
	truth:
		"James 1:18,John 16:13,14:16-18,John 14:6,17:17,3:21,4:24,1 John 2:27, John 8:31-32,14:6,  Eph1:13, 4:21, 5:9, 1 Pet 1:22,  2 Tim 4:3-4;",
	"turn inward": "Rom 1:19,7:22, Psa 51:6,Rom 10:8,Deu 30:10-14,Luke 17:21 ;",
	"turned over to demons":
		"Job 16:9-14,Psa 23,25:2, 35:11-12,15-17,Eph 6:16,Psa  38:12, 56:1-2,5-6,66:11-12, Psa 141:8-9;",
	"turns aside": "1 Tim 1:6, 2 Pet 2:19,Eze 13:22,1 Tim 5:15;",
	twisted: "2 Pet 3:15-16, Mat 15:3, Jude 1:4, Rom 7:4, 2 Tim 4:3-4;",
	union:
		"2 Pet 1:4,Eph 2:5,3:19, 5:30,John 14:19-21,23,John 17:20-23, Heb 2:11, 3:14,Eph 4:13,1 Cor 6:17;",
	unity:
		"Col 2:2,1 Cor 12:12,Eph 4:13,Rom15:6,Phil  2:2,Eph  4:3-5,1 Cor 12:13;",
	utterance: "2 Cor 8:7,Eph 6:19,Acts 2:4,1 Cor 1:5 ;",
	"vain opinions":
		"Jer 14:14,23:26,2 Peter 2:3,18 ,Eph 5:5-6,Eze 13:2,10,22,Rom 16:18, 1 Tim 4:1-2,2 Tim 4:3-4;",
	vanity: "Psa 94:11,Eph  4:17,Psa 12:2, 4:2, Ecc 7:6, 2:1;",
	victory: "1 Cor 15:55,57,Hebrews 10:23,3:6,1 John 5:4,Rev 15:2;",
	violence: "Psa 11:5,Gen 6:11-13;",
	virgins: "2 Cor 11:2, Rev 14:3-5, Mat 19:12,14;",
	vision:
		"Gen 15:1,46:2,Num 12:6,2 Chron 26:5,Dan 2:19,Hosea 12:10,Joel 2:28,Acts 10:19, Acts 18:9,Acts 16:9, 2 Cor 12:1;",
	visitation:
		"Mat 22:14,Tit 2:11-12,John 1:9,John 3:19,John 12:48,Rev 3:20,John 16:8-9;",
	"voice like thunder":
		"2 Sam 22:14,Job 37:4,5, 40:9,Psa 18:13,29:3,77:18, 104:7;",
	wait: "Isa 40:31,25:9,Pro 8:34,Hos 12:6,Heb 9:28,Isa 64:4,26:8,Gal 5:5,Lam 3:25,Psa 37:7,9,27:14,33:20,Psa 62:1,33:22, 31:24;",
	"wait and hope":
		"Psa 33:20,22,Psa 27:14,31:24,Lam 3:26,3:25,Psa 130:5,38:15,Psa 39:7;",
	"wait for salvation":
		"Psa 62:1,25:5,Luke 21:19,Heb 9:28,Rom 8:25,Heb 6:15,Lam 3:25-26;",
	"wait in New Testament":
		"1 Cor 1:7,Rom 8:25,James 5:7,Heb 9:28,2 Pet 3:12,Gal 5:5,Rom 8:23,2 The 3:5,1 The 1:10;",
	"wait in Old Testament":
		"Isa 40:31,64:4,25:9,30:18,Isa 49:23,26:8,33:2,8:17,Pro 8:34,20:22,Hos 12:6, Lam 3:25,26,Mic 7:7,Psa 37:9,31:24,33:22, 62:1,27:14,Psa 39:7,37:7,34,40:1,Psa 123:2,130:5,6,3:20,5:3,38:15;",
	"walk as He walked":
		"James 1:22,Tit 1:10,1 John 2:6,Col 2:6,Rom 6:4,Rom 4:12;",
	"walk in darkness":
		"Isa 59:9-10,Psa 82:5,Luke 11:34-36,John 1:5,John 12:35,Luke 1:79,John 11:10,Mat 6:23,Isa 50:10;",
	"walk in the light":
		"Rev 21:23-24,Luke 1:78-79,Eph 5:8,John 8:12,Col 1:12,Isa 2:5,60:19,Psa  32:8,97:11,56:13,1 John 1:7;",
	"walk in the Spirit": "Rom 8:1,4, Rom 8:5,14;",
	"walk not talk": "James 1:22,,Mat 23:3;",
	war: "1 Peter 2:11,Gal 5:17,1 John 5:4-5,1 Tim 6:12,2 Tim 4:7;",
	wash: "1 John 5:8,Eph 5:25-27, Heb 10:22, Psa 119:9, Psa 51:2,7,10,Tit 3:5, John 15:3, 13:8,Rev 7:14,Mal 3:2-3;",
	watch:
		"Psa 119:82,2 Cor  11:27,Luke 12:36-38,Pro 8:34-35,Mat 26:36,38,40-41,Psa 5:3,119:9,1 Cor 16:13;",
	"weeping and gnashing": "Mat 25:29-30,Mat 22:12-13,Mat 24:48-51;",
	"who still sins does not know the Lord":
		"Mat 7:21-23,1 John 3:6,Mat 25:8-12,John 10:27, 18:37;",
	"will of God":
		"Rom 12:2,Heb 13:20-21,Mat 7:21,1 Pet 4:1-2,Gal 5:17,Mark 3:35,1 Thes 4:3-5,7,Heb 10:36,39, Eph 5:17,Col 4:12;",
	"will-worship": "Col 2:20-23;",
	wisdom:
		"James 3:17,Pro 4:7,16:16,23:23,Pro 11:12,24:3,10:21,Pro 4:5,15:33,9:10,1 Cor 1:24;",
	"witness Christ within":
		"John 6:40,1John 5:10,2 Cor 4:6 ,3:18, 1 John 3:2-3;",
	Wives: "Tit 2:3-5,1 Pet 3:1-6,Eph 5:21-25, Col 3:18;",
	word: "Acts 10:44,4:31,2 Corinthians 2:17,2 Corinthians 13:3,12:19,1 Corinthians 2:13,1 Peter 4:11,John 7:18,12:49,Romans 10:8,Ephesians 6:19,2 Peter 1:21",
	"word created the earth and the heavens": "Heb 11:3, 2 Pet 3:5-7, Psa 33:6;",
	"word endures forever": "1 Pet 1:23,25;",
	"word is a living being":
		"Psa 33:6, Rev 19:13-16,John 1:14, Psa 33:4,1 Peter 1:23,25, Heb 11:3, John 1:1-2;",
	"Word of God came":
		"Gen 15:4,1 Kings 12:22, Luke 3:2,1 Chron 17:3, John 10:34-35, Jer 18:1, Eze 33:1,Jonah 1:1, Zech 1:7;",
	"word of life": "Phil 2:16,1 John 1:1;",
	"word of truth": "2 Cor 6:7,Eph 1:13, Col 1:5,James 1:18,Psa 119:43;",
	"word put in mouth":
		"Num 22:38,23:12,Deu 18:18,Isa 59:21,Isa 51:16,Isa 59:21,Jer 1:9,5:14;",
	"word refs in Acts": "Acts  6:2,7,Acts 13:5,4:31,12:24,  Acts 8:14,11:1;",
	"word within":
		"Col 3:16,Eph 4:21, 1:13,Rom 10:8,17,Deu 30:12-14,1 John 2:14, 1:1,14,1 Pet 1:23, 25,Rev 19:13-16;",
	"words from man":
		"Mat 5:37, John 2:25,2 Cor 2:17, James 3:1-2,James 1:26, Tit 1:10,Mat 12:36, Mat 12:37;",
	"words from mouth of God":
		"Pro4:5,5:7,Pro 7:24,Mat 4:4,Pro 2:6,8:6,8,Isa 45:23,Jer 9:20,Isa 55:11,Eze 3:17,33:7,Psa 78:1,89:34,17:4;",
	"words from the Spirit":
		"Acts 10:44,4:31,2 Cor 2:17,2 Cor13:3,12:19,1 Cor 2:13,1 Pet 4:11,John 7:18,12:49,Rom 10:8,Eph6:19,2 Pet 1:21;",
	works:
		"Tit 2:14,Eph 2:10,John 3:21,John 5:19,Heb 13:20-21,Mat 5:16,Gal 5:6,Phil 2:13 ;",
	"works of men":
		"Gal 5:19-21, Col 3:5,8-9, Eph 5:3,4:22,\nRom 8:13, Eph 2:2, Eph 2:3, Eph 4:17;",
	"works of obedience":
		"Gal 5:6,Tit 2:14,2 Tim 2:21,Rom 6:13,John 3:21,Eph 2:10,James 2:20-24;",
	"works of unregenerated men":
		"Mat 12:30,23:15, John 2:25, John 7:18,Rev 13:10;",
	"world ends":
		"1 John 2:17,1 Cor 10:11,7:31,Mat  28:20,13:38-41,2 Pet 3:10-12,Rev 21:1,2 Cor 5:17;",
	"worship in vain": "Mat 15:3,9, Mark 7:7-8;",
	"yesterday today forever": "Heb 13:8, Heb 1:11-12,Psa 102:25-27, Mal 3:6;",
	appear:
		"Titus 2:13,2 Peter 3:12,2 Corinthians 4:6,3:18,Matthew 5:8,John 14:21-23,1 John 3:2-3,1 John 2:28,Colossians 3:4,Isaiah 30:20",

	clean:
		"1 John 1:7,9,John 15:3,13:8,Ephesians 5:25-27,Isaiah 35:8,52:1,Psalms 119:9,51:2,10,19:12,Luke 11:39,41,2 Corinthians 7:1,Hebrews 1:3,Hebrews 10:14,22",
	cleansed:
		"1 John 1:7,9,John 15:3,13:8,Eph 5:25-27,Isa 35:8, 52:1,Psa  119:9,51:2,10,19:12,Luke 11:39,41,2 Cor 7:1,Heb 1:3,Heb 10:14,22;",
	deed: "Titus 2:14,Ephesians 2:10,John 3:21,John 5:19,Hebrews 13:20-21,Matthew 5:16,2 Timothy 2:21,Philippians 2:13",
	deeds:
		"Titus 2:14,Ephesians 2:10,John 3:21,John 5:19,Hebrews 13:20-21,Matthew 5:16,2 Timothy 2:21,Philippians 2:13",

	free: "Acts 26:17-18,1 John 3:9,5:18,3:6,1 Peter 4:1-2,John 8:32,34,36,Romans 6:18,22,Colossians 2:11,3:5,Titus 2:13-14",
	"free pass discredited":
		"Isaiah 28:15,Isaiah 28:18,2 Corinthians 5:10,Proverbs 24:12,Proverbs 24:24",

	holy: "2 Corinthians 7:1,Romans 6:22,Hebrews 12:10,14,1 Peter 1:15-17,Isaiah 35:8,Luke 1:74-75,1 Thessalonians 4:3-5,7",
	home: "Leviticus 26:11-12,John 14:23,John 1:14,2 Corinthians 6:16,Ezekiel 37:27,36:26-28,Revelation 21:3,Colossians 3:16",

	"go to Him":
		"Isaiah 55:1,3,Matthew 11:28-29,Luke 6:47-49,John 5:39-40,John 6:37,6:35",

	life: "John 6:33,35,John 1:4,11:25,John 14:6,5:40,John 10:10,John 6:63,12:25,John 8:12,2 Corinthians 3:6",

	persist:
		"Hebrews 3:14,Hebrews 6:11-12,Matthew 7:8,Hebrews 9:28,Luke 8:15,1 Peter 1:6,9,1 Timothy 5:5,Revelation 2:3",

	power:
		"Colossians 1:28-29,Romans 1:16,1 Corinthians 1:24,1 Corinthians 1:18,Ephesians 3:20,Ephesians 3:19,16,John 1:12,2 Timothy 3:5",

	pure: "Matthew 5:8,Acts 15:9,James 4:8-10,Acts 26:18,1 Peter 1:22,1 John 3:3,Titus 2:14,Daniel 12:10,Malachi 3:2-3",

	raised:
		"Colossians 2:12,3:1,Ephesians 2:6,John 5:25,Romans 6:13,2 Corinthians 4:14,Philippians 3:10-11",

	revealed:
		"1 John 3:8,John 14:21-23,Galatians 1:15-16,Isaiah 30:20,1 Peter 1:13,4:13,2 Corinthians 4:10-11,Luke 10:22,17:30",

	sanctification:
		"John 17:17,John 17:19,Ephesians 5:25-26,Hebrews 10:14,Hebrews 2:11",

	serve:
		"Hebrews 9:14,Luke 1:74-75,Hebrews 12:28,John 12:26,Romans 6:22,Revelation 22:3,Revelation 7:15",

	speak:
		"Acts 10:44, Acts 4:31, 2 Cor 2:17, 2 Cor 13:3, 2 Cor 12:19, 1 Cor 2:13, 1 Pet 4:11, John 7:18,12:49, Rom 10:8, Eph 6:19, 2 Pet 21",

	"take up the cross":
		"Matthew 10:38,Luke 14:27,33,9:23,1 Corinthians 1:18,Matthew 16:24-25,Galatians 5:24,2:20,2 Corinthians 4:10-11",

	thought:
		"2 Corinthians 10:5,1 Corinthians 2:16,Hebrews 8:10,Ephesians 4:22-24,Romans 12:2",
	thoughts:
		"2 Corinthians 10:5,1 Corinthians 2:16,Hebrews 8:10,Ephesians 4:22-24,Romans 12:2",

	words:
		"Acts 10:44,4:31,2 Corinthians 2:17,2 Corinthians 13:3,12:19,1 Corinthians 2:13,1 Peter 4:11,John 7:18,12:49,Romans 10:8,Ephesians 6:19,2 Peter 1:21",
};
